<a href="../assets/resume/Resume.pdf">Download</a>

<div class="pdf-viewer">
    <object type="application/pdf"
        data="../assets/resume/Resume.pdf#toolbar=0&navpanes=0&view=FitH"
    ></object>
</div>
